/**
 * Tagged free-health-check CTA for each /fix page. The page body and the
 * marketing header both read this map, so a click on the header "Get Started"
 * from a fix page is attributed to that page's campaign instead of arriving
 * untagged (the header link is the first health-check link in the DOM).
 */
export const FIX_PAGE_CTA_PATHS: Readonly<Record<string, string>> = {
  "/fix/salesforce-integration-user-frozen":
    "/free-health-check?utm_source=fix&utm_medium=seo&utm_campaign=fix-salesforce-integration-user-frozen",
  "/fix/php2shell-salesforce-credentials":
    "/free-health-check?utm_source=fix&utm_medium=organic&utm_campaign=2026-10-30-php2shell-credentials",
};

const DEFAULT_CTA_PATH = "/free-health-check";

/** The health-check CTA path for a route; untagged for routes not in the map. */
export function healthCheckCtaPath(pathname: string | null | undefined): string {
  return (pathname && FIX_PAGE_CTA_PATHS[pathname]) || DEFAULT_CTA_PATH;
}
